import { Chip, LinearProgress, Stack, Switch, Typography } from "@mui/material";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { useEffect, useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "randmarcomps";
import ReturnGrid from "../components/grids/ReturnGrid";
import ReturnsActions from '../components/returns/ReturnsActions';
import ButtonWithActions from "../components/util/ButtonWithActions";
import { DocumentHeader } from "../components/util/StyledComponents";
import withManufacturer from "../contexts/WithManufacturer";
import { RootStore } from "../stores/rootStore";
import withRoot from "../withRoot";

interface IProps {
  store?: RootStore;
  applicationId: string;
}

const Returns: React.FC<IProps> = ({ store, applicationId }) => {
  const [loading, setLoading] = useState(true);
  const { returnsStore } = store!;

  useEffect(() => {
    const fetchReturns = async () => {
      await returnsStore.getReturns(applicationId);
      setLoading(false);
    };

    fetchReturns();
  }, [applicationId, returnsStore]);

  const handleSwitchChange = (propName: string, newValue: string) => {
    console.log(propName);
    console.log(newValue);
  };

  const { returns } = returnsStore;

  return (
    <>
      {loading ? <LinearProgress /> : <LinearProgress variant="determinate" value={100} />}
      <DocumentHeader justifyContent="space-between" alignItems="center" direction="row">
        <div>
          <Typography variant="h1">Returns</Typography>
          {loading && <LinearProgress sx={{ mt: 0.5, height: "2px" }} />}
        </div>
        <Stack direction={{ xs: "column-reverse", md: "row" }} spacing={1} justifyContent="center" alignItems={{ xs: "left", md: "center" }}>
          <Chip
            color="primary"
            label={<b>Accept Returns</b>}
            variant="outlined"
            onDelete={(e: any) => handleSwitchChange("AcceptReturns", e.target.checked.toString())}
            deleteIcon={
              <Switch
                size="small"
                checked
                disabled
                //checked={acceptReturns}
                name={"SwitchAcceptReturns"}
                color="primary"
              />
            }
          />
          <ButtonWithActions buttonText="Actions">
            <ReturnsActions />
          </ButtonWithActions>
        </Stack>
      </DocumentHeader>
      <Alert variant="info" className="mb-4">
        <AlertTitle>What Returns?</AlertTitle>
        <AlertDescription>
          The returns reflected here are defectives items received in our warehouses from these resellers.
        </AlertDescription>
      </Alert>
      <ReturnGrid returns={returns.filter(v => v.status === "Received")} />
    </>
  );
};

export default withRoot(withManufacturer(inject("store")(observer(Returns))));
